var SupportBasePresentation, SupportLiveVoucherPresenterPresentation, SupportLiveVoucherStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportLiveVoucherStatusAndNotesPresentation = require('./live_voucher_messages');

SupportLiveVoucherPresenterPresentation = (function(superClass) {
  extend(SupportLiveVoucherPresenterPresentation, superClass);

  function SupportLiveVoucherPresenterPresentation() {
    return SupportLiveVoucherPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportLiveVoucherPresenterPresentation.prototype.getLookupObject = function() {
    return SupportLiveVoucherStatusAndNotesPresentation;
  };

  return SupportLiveVoucherPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportLiveVoucherPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9saXZlX3ZvdWNoZXJfcHJlc2VudGVyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvbGl2ZV92b3VjaGVyX3ByZXNlbnRlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw4R0FBQTtFQUFBOzs7QUFBQSx1QkFBQSxHQUEwQixPQUFBLENBQVEsUUFBUjs7QUFDMUIsNENBQUEsR0FBK0MsT0FBQSxDQUFRLHlCQUFSOztBQUV6Qzs7Ozs7OztvREFDTCxlQUFBLEdBQWlCLFNBQUE7V0FDaEI7RUFEZ0I7Ozs7R0FEb0M7O0FBSXRELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
